import styled from 'styled-components';
import { Col } from 'reactstrap';

export const ItemTitle = styled.h2`
  font-size: 1.0625rem;
  line-height: 1.25rem;
  font-weight: 300;
  @media (min-width: 768px) {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
  &.feature_size {
    font-size: 1.125rem;
    line-height: 1.375rem;
    @media (min-width: 768px) {
      font-size: 1.375rem;
      line-height: 1.625rem;
    }
    @media (min-width: 992px) {
      font-size: 1.5rem;
      line-height: 1.75rem;
    }
  }
`;

export const CustomCol = styled(Col)`
  &:not(.fluid) {
    @media (min-width: 480px) {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
  }
`